import React from 'react'

import { user } from '../../core/controllers/user';
import PropertiesList from '../../components/Properties/PropertiesList';
import PropertyCards from '../../components/Properties/PropertyCards';

export default class PropertiesTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    render(){
        return (
            <div class="col-md-12">
                {/* <div class="card">
                    <div class="header">
                        <h4 class="title">Properties</h4>
                        <p class="category"></p>
                    </div>
                    <div class="content">
                        <PropertiesList sortID={0}/>
                    </div>
                </div> */}
                <PropertyCards sortID={0}/>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Properties/Properties.jsx